/*
 * @Author: zhengshuhua
 * @Date: 2021-09-14 09:24:25
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2023-12-23 11:35:57
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\local\setter.js
 */
import state from './state'
import localApi from './localapi'
const setter = {
	setCenterCode(value) {
		return localApi.setLocal(state.centerCode, value)
	},
	setNetworkFlag(value) {
		return localApi.setLocal(state.networkFlag, value)
	},
	setResearchCode(value) {
		return localApi.setLocal(state.researchCode, value)
	},
	setRouteMoreRecord(name, value) {
		const info = JSON.parse(localApi.getLocal(state.routeMoreRecord) || '{}')
		info[name] = value
		return localApi.setLocal(state.routeMoreRecord, JSON.stringify(info))
	},
	setUserInfo(value) {
		return localApi.setLocal(state.userInfo, JSON.stringify(value))
	},
	setUserToken(value) {
		return localApi.setLocal(state.userToken, value)
	},
	setUserAuthority(value) {
		return localApi.setLocal(state.userAuthority, JSON.stringify(value))
	},
	setIdentityType(value) {
		return localApi.setSession(state.identityType, value)
	},
	setUserOpenId(value) {
		return localApi.setLocal(state.userOpenId, value)
	},
	setTesteeScrollTop(value) {
		return localApi.setSession(state.testeeScrollTop, value)
	},
	setResearchScrollTop(value) {
		return localApi.setSession(state.researchScrollTop, value)
	},
	setTesteePaginationConfig(value) {
		return localApi.setLocal(state.testeePaginationConfig, JSON.stringify(value))
	},
	setRecruitPaginationConfig(value) {
		return localApi.setLocal(state.recruitPaginationConfig, JSON.stringify(value))
	}
	// setRecruitPaginationConfig(value) {
	// 	return localApi.setLocal(state.recruitPaginationConfig, JSON.stringify(value))
	// }
}
export default setter
